
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

import { sharedState } from '../state';
import { getFieldNameFromVModelProperty } from '../util/component_util';
import { passwordRegexp, textInputRegexp } from '../../../common/application/logic/text_input_regexp';

@Component({
    components: { ValidationProvider },
})
export default class PasswordField extends Vue {
    @Prop(String) name!: string;
    @Prop(String) readonly value!: string;
    @Prop(Boolean) readonly readonly!: string;
    @Prop(Boolean) readonly required!: boolean;
    @Prop(Boolean) readonly disabled!: string;
    @Prop(Boolean) readonly horizontal!: boolean;
    @Prop(Boolean) readonly newPassword!: boolean;

    shared = sharedState;
    local = {
        value: undefined as string | undefined,
        regex: this.newPassword ? passwordRegexp : textInputRegexp,
    };

    async mounted() {
        await this.modelValueChange(this.value);
    }

    @Watch('value')
    async modelValueChange(newValue: string) {
        this.local.value = newValue;
    }

    @Watch('local.value')
    async inputValueChange(newValue: string) {
        this.$emit('input', newValue);
    }

    getFieldName() {
        return getFieldNameFromVModelProperty(this);
    }

    onEnter() {
        this.$emit('enter');
    }

    get isDisabled() {
        return this.disabled === 'true';
    }
}
